export const PREMIUM_PRICE_ALGORITHM = {
  name: 'exponential',
  totalDays: 21,
  startingPremium: 100000000
}
